/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DailyKnowledgeRouteImport } from './routes/daily-knowledge'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReviewCenterIndexRouteImport } from './routes/review-center/index'
import { Route as QuizletsIndexRouteImport } from './routes/quizlets/index'
import { Route as ArticlesIndexRouteImport } from './routes/articles/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as QuizletsCreateRouteImport } from './routes/quizlets/create'
import { Route as QuizletsQuizletIdRouteImport } from './routes/quizlets/$quizletId'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as ArticlesPublicRouteImport } from './routes/articles/public'
import { Route as ArticlesCreateRouteImport } from './routes/articles/create'
import { Route as ArticlesArticleIdRouteImport } from './routes/articles/$articleId'
import { Route as AnalyticsQuizletsRouteImport } from './routes/analytics/quizlets'
import { Route as AnalyticsQuizletIdRouteImport } from './routes/analytics/$quizletId'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AccountUsageRouteImport } from './routes/account/usage'
import { Route as ArticlesCollectionsIndexRouteImport } from './routes/articles/collections/index'
import { Route as ReviewCenterQuizIdReviewRouteImport } from './routes/review-center/$quizId.review'
import { Route as ReviewCenterQuizIdPracticeRouteImport } from './routes/review-center/$quizId.practice'
import { Route as QuizletsDeckGroupsCreateRouteImport } from './routes/quizlets/deck-groups/create'
import { Route as QuizletsDeckGroupsGroupIdRouteImport } from './routes/quizlets/deck-groups/$groupId'
import { Route as QuizletsQuizletIdEditRouteImport } from './routes/quizlets/$quizletId.edit'
import { Route as ArticlesCollectionsCollectionIdRouteImport } from './routes/articles/collections/$collectionId'
import { Route as ArticlesArticleIdEditRouteImport } from './routes/articles/$articleId.edit'
import { Route as QuizletsDeckGroupsGroupIdEditRouteImport } from './routes/quizlets/deck-groups/$groupId.edit'
import { Route as ArticlesCollectionsCollectionIdArticlesArticleIdRouteImport } from './routes/articles/collections/$collectionId.articles.$articleId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DailyKnowledgeRoute = DailyKnowledgeRouteImport.update({
  id: '/daily-knowledge',
  path: '/daily-knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewCenterIndexRoute = ReviewCenterIndexRouteImport.update({
  id: '/review-center/',
  path: '/review-center/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizletsIndexRoute = QuizletsIndexRouteImport.update({
  id: '/quizlets/',
  path: '/quizlets/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const QuizletsCreateRoute = QuizletsCreateRouteImport.update({
  id: '/quizlets/create',
  path: '/quizlets/create',
  getParentRoute: () => rootRouteImport,
} as any)
const QuizletsQuizletIdRoute = QuizletsQuizletIdRouteImport.update({
  id: '/quizlets/$quizletId',
  path: '/quizlets/$quizletId',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => CheckoutRoute,
} as any)
const ArticlesPublicRoute = ArticlesPublicRouteImport.update({
  id: '/articles/public',
  path: '/articles/public',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesCreateRoute = ArticlesCreateRouteImport.update({
  id: '/articles/create',
  path: '/articles/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesArticleIdRoute = ArticlesArticleIdRouteImport.update({
  id: '/articles/$articleId',
  path: '/articles/$articleId',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsQuizletsRoute = AnalyticsQuizletsRouteImport.update({
  id: '/analytics/quizlets',
  path: '/analytics/quizlets',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsQuizletIdRoute = AnalyticsQuizletIdRouteImport.update({
  id: '/analytics/$quizletId',
  path: '/analytics/$quizletId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AccountUsageRoute = AccountUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AccountRoute,
} as any)
const ArticlesCollectionsIndexRoute =
  ArticlesCollectionsIndexRouteImport.update({
    id: '/articles/collections/',
    path: '/articles/collections/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReviewCenterQuizIdReviewRoute =
  ReviewCenterQuizIdReviewRouteImport.update({
    id: '/review-center/$quizId/review',
    path: '/review-center/$quizId/review',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReviewCenterQuizIdPracticeRoute =
  ReviewCenterQuizIdPracticeRouteImport.update({
    id: '/review-center/$quizId/practice',
    path: '/review-center/$quizId/practice',
    getParentRoute: () => rootRouteImport,
  } as any)
const QuizletsDeckGroupsCreateRoute =
  QuizletsDeckGroupsCreateRouteImport.update({
    id: '/quizlets/deck-groups/create',
    path: '/quizlets/deck-groups/create',
    getParentRoute: () => rootRouteImport,
  } as any)
const QuizletsDeckGroupsGroupIdRoute =
  QuizletsDeckGroupsGroupIdRouteImport.update({
    id: '/quizlets/deck-groups/$groupId',
    path: '/quizlets/deck-groups/$groupId',
    getParentRoute: () => rootRouteImport,
  } as any)
const QuizletsQuizletIdEditRoute = QuizletsQuizletIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => QuizletsQuizletIdRoute,
} as any)
const ArticlesCollectionsCollectionIdRoute =
  ArticlesCollectionsCollectionIdRouteImport.update({
    id: '/articles/collections/$collectionId',
    path: '/articles/collections/$collectionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ArticlesArticleIdEditRoute = ArticlesArticleIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ArticlesArticleIdRoute,
} as any)
const QuizletsDeckGroupsGroupIdEditRoute =
  QuizletsDeckGroupsGroupIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => QuizletsDeckGroupsGroupIdRoute,
  } as any)
const ArticlesCollectionsCollectionIdArticlesArticleIdRoute =
  ArticlesCollectionsCollectionIdArticlesArticleIdRouteImport.update({
    id: '/articles/$articleId',
    path: '/articles/$articleId',
    getParentRoute: () => ArticlesCollectionsCollectionIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/checkout': typeof CheckoutRouteWithChildren
  '/daily-knowledge': typeof DailyKnowledgeRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/account/usage': typeof AccountUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/analytics/$quizletId': typeof AnalyticsQuizletIdRoute
  '/analytics/quizlets': typeof AnalyticsQuizletsRoute
  '/articles/$articleId': typeof ArticlesArticleIdRouteWithChildren
  '/articles/create': typeof ArticlesCreateRoute
  '/articles/public': typeof ArticlesPublicRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/quizlets/$quizletId': typeof QuizletsQuizletIdRouteWithChildren
  '/quizlets/create': typeof QuizletsCreateRoute
  '/account/': typeof AccountIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/articles': typeof ArticlesIndexRoute
  '/quizlets': typeof QuizletsIndexRoute
  '/review-center': typeof ReviewCenterIndexRoute
  '/articles/$articleId/edit': typeof ArticlesArticleIdEditRoute
  '/articles/collections/$collectionId': typeof ArticlesCollectionsCollectionIdRouteWithChildren
  '/quizlets/$quizletId/edit': typeof QuizletsQuizletIdEditRoute
  '/quizlets/deck-groups/$groupId': typeof QuizletsDeckGroupsGroupIdRouteWithChildren
  '/quizlets/deck-groups/create': typeof QuizletsDeckGroupsCreateRoute
  '/review-center/$quizId/practice': typeof ReviewCenterQuizIdPracticeRoute
  '/review-center/$quizId/review': typeof ReviewCenterQuizIdReviewRoute
  '/articles/collections': typeof ArticlesCollectionsIndexRoute
  '/quizlets/deck-groups/$groupId/edit': typeof QuizletsDeckGroupsGroupIdEditRoute
  '/articles/collections/$collectionId/articles/$articleId': typeof ArticlesCollectionsCollectionIdArticlesArticleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/checkout': typeof CheckoutRouteWithChildren
  '/daily-knowledge': typeof DailyKnowledgeRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/account/usage': typeof AccountUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/analytics/$quizletId': typeof AnalyticsQuizletIdRoute
  '/analytics/quizlets': typeof AnalyticsQuizletsRoute
  '/articles/$articleId': typeof ArticlesArticleIdRouteWithChildren
  '/articles/create': typeof ArticlesCreateRoute
  '/articles/public': typeof ArticlesPublicRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/quizlets/$quizletId': typeof QuizletsQuizletIdRouteWithChildren
  '/quizlets/create': typeof QuizletsCreateRoute
  '/account': typeof AccountIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/articles': typeof ArticlesIndexRoute
  '/quizlets': typeof QuizletsIndexRoute
  '/review-center': typeof ReviewCenterIndexRoute
  '/articles/$articleId/edit': typeof ArticlesArticleIdEditRoute
  '/articles/collections/$collectionId': typeof ArticlesCollectionsCollectionIdRouteWithChildren
  '/quizlets/$quizletId/edit': typeof QuizletsQuizletIdEditRoute
  '/quizlets/deck-groups/$groupId': typeof QuizletsDeckGroupsGroupIdRouteWithChildren
  '/quizlets/deck-groups/create': typeof QuizletsDeckGroupsCreateRoute
  '/review-center/$quizId/practice': typeof ReviewCenterQuizIdPracticeRoute
  '/review-center/$quizId/review': typeof ReviewCenterQuizIdReviewRoute
  '/articles/collections': typeof ArticlesCollectionsIndexRoute
  '/quizlets/deck-groups/$groupId/edit': typeof QuizletsDeckGroupsGroupIdEditRoute
  '/articles/collections/$collectionId/articles/$articleId': typeof ArticlesCollectionsCollectionIdArticlesArticleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/checkout': typeof CheckoutRouteWithChildren
  '/daily-knowledge': typeof DailyKnowledgeRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/account/usage': typeof AccountUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/analytics/$quizletId': typeof AnalyticsQuizletIdRoute
  '/analytics/quizlets': typeof AnalyticsQuizletsRoute
  '/articles/$articleId': typeof ArticlesArticleIdRouteWithChildren
  '/articles/create': typeof ArticlesCreateRoute
  '/articles/public': typeof ArticlesPublicRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/quizlets/$quizletId': typeof QuizletsQuizletIdRouteWithChildren
  '/quizlets/create': typeof QuizletsCreateRoute
  '/account/': typeof AccountIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/articles/': typeof ArticlesIndexRoute
  '/quizlets/': typeof QuizletsIndexRoute
  '/review-center/': typeof ReviewCenterIndexRoute
  '/articles/$articleId/edit': typeof ArticlesArticleIdEditRoute
  '/articles/collections/$collectionId': typeof ArticlesCollectionsCollectionIdRouteWithChildren
  '/quizlets/$quizletId/edit': typeof QuizletsQuizletIdEditRoute
  '/quizlets/deck-groups/$groupId': typeof QuizletsDeckGroupsGroupIdRouteWithChildren
  '/quizlets/deck-groups/create': typeof QuizletsDeckGroupsCreateRoute
  '/review-center/$quizId/practice': typeof ReviewCenterQuizIdPracticeRoute
  '/review-center/$quizId/review': typeof ReviewCenterQuizIdReviewRoute
  '/articles/collections/': typeof ArticlesCollectionsIndexRoute
  '/quizlets/deck-groups/$groupId/edit': typeof QuizletsDeckGroupsGroupIdEditRoute
  '/articles/collections/$collectionId/articles/$articleId': typeof ArticlesCollectionsCollectionIdArticlesArticleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/admin'
    | '/checkout'
    | '/daily-knowledge'
    | '/login'
    | '/pricing'
    | '/signup'
    | '/account/usage'
    | '/admin/users'
    | '/analytics/$quizletId'
    | '/analytics/quizlets'
    | '/articles/$articleId'
    | '/articles/create'
    | '/articles/public'
    | '/checkout/success'
    | '/quizlets/$quizletId'
    | '/quizlets/create'
    | '/account/'
    | '/analytics'
    | '/articles'
    | '/quizlets'
    | '/review-center'
    | '/articles/$articleId/edit'
    | '/articles/collections/$collectionId'
    | '/quizlets/$quizletId/edit'
    | '/quizlets/deck-groups/$groupId'
    | '/quizlets/deck-groups/create'
    | '/review-center/$quizId/practice'
    | '/review-center/$quizId/review'
    | '/articles/collections'
    | '/quizlets/deck-groups/$groupId/edit'
    | '/articles/collections/$collectionId/articles/$articleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/admin'
    | '/checkout'
    | '/daily-knowledge'
    | '/login'
    | '/pricing'
    | '/signup'
    | '/account/usage'
    | '/admin/users'
    | '/analytics/$quizletId'
    | '/analytics/quizlets'
    | '/articles/$articleId'
    | '/articles/create'
    | '/articles/public'
    | '/checkout/success'
    | '/quizlets/$quizletId'
    | '/quizlets/create'
    | '/account'
    | '/analytics'
    | '/articles'
    | '/quizlets'
    | '/review-center'
    | '/articles/$articleId/edit'
    | '/articles/collections/$collectionId'
    | '/quizlets/$quizletId/edit'
    | '/quizlets/deck-groups/$groupId'
    | '/quizlets/deck-groups/create'
    | '/review-center/$quizId/practice'
    | '/review-center/$quizId/review'
    | '/articles/collections'
    | '/quizlets/deck-groups/$groupId/edit'
    | '/articles/collections/$collectionId/articles/$articleId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/admin'
    | '/checkout'
    | '/daily-knowledge'
    | '/login'
    | '/pricing'
    | '/signup'
    | '/account/usage'
    | '/admin/users'
    | '/analytics/$quizletId'
    | '/analytics/quizlets'
    | '/articles/$articleId'
    | '/articles/create'
    | '/articles/public'
    | '/checkout/success'
    | '/quizlets/$quizletId'
    | '/quizlets/create'
    | '/account/'
    | '/analytics/'
    | '/articles/'
    | '/quizlets/'
    | '/review-center/'
    | '/articles/$articleId/edit'
    | '/articles/collections/$collectionId'
    | '/quizlets/$quizletId/edit'
    | '/quizlets/deck-groups/$groupId'
    | '/quizlets/deck-groups/create'
    | '/review-center/$quizId/practice'
    | '/review-center/$quizId/review'
    | '/articles/collections/'
    | '/quizlets/deck-groups/$groupId/edit'
    | '/articles/collections/$collectionId/articles/$articleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  CheckoutRoute: typeof CheckoutRouteWithChildren
  DailyKnowledgeRoute: typeof DailyKnowledgeRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  SignupRoute: typeof SignupRoute
  AnalyticsQuizletIdRoute: typeof AnalyticsQuizletIdRoute
  AnalyticsQuizletsRoute: typeof AnalyticsQuizletsRoute
  ArticlesArticleIdRoute: typeof ArticlesArticleIdRouteWithChildren
  ArticlesCreateRoute: typeof ArticlesCreateRoute
  ArticlesPublicRoute: typeof ArticlesPublicRoute
  QuizletsQuizletIdRoute: typeof QuizletsQuizletIdRouteWithChildren
  QuizletsCreateRoute: typeof QuizletsCreateRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  ArticlesIndexRoute: typeof ArticlesIndexRoute
  QuizletsIndexRoute: typeof QuizletsIndexRoute
  ReviewCenterIndexRoute: typeof ReviewCenterIndexRoute
  ArticlesCollectionsCollectionIdRoute: typeof ArticlesCollectionsCollectionIdRouteWithChildren
  QuizletsDeckGroupsGroupIdRoute: typeof QuizletsDeckGroupsGroupIdRouteWithChildren
  QuizletsDeckGroupsCreateRoute: typeof QuizletsDeckGroupsCreateRoute
  ReviewCenterQuizIdPracticeRoute: typeof ReviewCenterQuizIdPracticeRoute
  ReviewCenterQuizIdReviewRoute: typeof ReviewCenterQuizIdReviewRoute
  ArticlesCollectionsIndexRoute: typeof ArticlesCollectionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/daily-knowledge': {
      id: '/daily-knowledge'
      path: '/daily-knowledge'
      fullPath: '/daily-knowledge'
      preLoaderRoute: typeof DailyKnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review-center/': {
      id: '/review-center/'
      path: '/review-center'
      fullPath: '/review-center'
      preLoaderRoute: typeof ReviewCenterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quizlets/': {
      id: '/quizlets/'
      path: '/quizlets'
      fullPath: '/quizlets'
      preLoaderRoute: typeof QuizletsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/': {
      id: '/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof ArticlesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/quizlets/create': {
      id: '/quizlets/create'
      path: '/quizlets/create'
      fullPath: '/quizlets/create'
      preLoaderRoute: typeof QuizletsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quizlets/$quizletId': {
      id: '/quizlets/$quizletId'
      path: '/quizlets/$quizletId'
      fullPath: '/quizlets/$quizletId'
      preLoaderRoute: typeof QuizletsQuizletIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/articles/public': {
      id: '/articles/public'
      path: '/articles/public'
      fullPath: '/articles/public'
      preLoaderRoute: typeof ArticlesPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/create': {
      id: '/articles/create'
      path: '/articles/create'
      fullPath: '/articles/create'
      preLoaderRoute: typeof ArticlesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$articleId': {
      id: '/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId'
      preLoaderRoute: typeof ArticlesArticleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/quizlets': {
      id: '/analytics/quizlets'
      path: '/analytics/quizlets'
      fullPath: '/analytics/quizlets'
      preLoaderRoute: typeof AnalyticsQuizletsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/$quizletId': {
      id: '/analytics/$quizletId'
      path: '/analytics/$quizletId'
      fullPath: '/analytics/$quizletId'
      preLoaderRoute: typeof AnalyticsQuizletIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/usage': {
      id: '/account/usage'
      path: '/usage'
      fullPath: '/account/usage'
      preLoaderRoute: typeof AccountUsageRouteImport
      parentRoute: typeof AccountRoute
    }
    '/articles/collections/': {
      id: '/articles/collections/'
      path: '/articles/collections'
      fullPath: '/articles/collections'
      preLoaderRoute: typeof ArticlesCollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review-center/$quizId/review': {
      id: '/review-center/$quizId/review'
      path: '/review-center/$quizId/review'
      fullPath: '/review-center/$quizId/review'
      preLoaderRoute: typeof ReviewCenterQuizIdReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review-center/$quizId/practice': {
      id: '/review-center/$quizId/practice'
      path: '/review-center/$quizId/practice'
      fullPath: '/review-center/$quizId/practice'
      preLoaderRoute: typeof ReviewCenterQuizIdPracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quizlets/deck-groups/create': {
      id: '/quizlets/deck-groups/create'
      path: '/quizlets/deck-groups/create'
      fullPath: '/quizlets/deck-groups/create'
      preLoaderRoute: typeof QuizletsDeckGroupsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quizlets/deck-groups/$groupId': {
      id: '/quizlets/deck-groups/$groupId'
      path: '/quizlets/deck-groups/$groupId'
      fullPath: '/quizlets/deck-groups/$groupId'
      preLoaderRoute: typeof QuizletsDeckGroupsGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quizlets/$quizletId/edit': {
      id: '/quizlets/$quizletId/edit'
      path: '/edit'
      fullPath: '/quizlets/$quizletId/edit'
      preLoaderRoute: typeof QuizletsQuizletIdEditRouteImport
      parentRoute: typeof QuizletsQuizletIdRoute
    }
    '/articles/collections/$collectionId': {
      id: '/articles/collections/$collectionId'
      path: '/articles/collections/$collectionId'
      fullPath: '/articles/collections/$collectionId'
      preLoaderRoute: typeof ArticlesCollectionsCollectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$articleId/edit': {
      id: '/articles/$articleId/edit'
      path: '/edit'
      fullPath: '/articles/$articleId/edit'
      preLoaderRoute: typeof ArticlesArticleIdEditRouteImport
      parentRoute: typeof ArticlesArticleIdRoute
    }
    '/quizlets/deck-groups/$groupId/edit': {
      id: '/quizlets/deck-groups/$groupId/edit'
      path: '/edit'
      fullPath: '/quizlets/deck-groups/$groupId/edit'
      preLoaderRoute: typeof QuizletsDeckGroupsGroupIdEditRouteImport
      parentRoute: typeof QuizletsDeckGroupsGroupIdRoute
    }
    '/articles/collections/$collectionId/articles/$articleId': {
      id: '/articles/collections/$collectionId/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/articles/collections/$collectionId/articles/$articleId'
      preLoaderRoute: typeof ArticlesCollectionsCollectionIdArticlesArticleIdRouteImport
      parentRoute: typeof ArticlesCollectionsCollectionIdRoute
    }
  }
}

interface AccountRouteChildren {
  AccountUsageRoute: typeof AccountUsageRoute
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountUsageRoute: AccountUsageRoute,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface AdminRouteChildren {
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CheckoutRouteChildren {
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
}

const CheckoutRouteChildren: CheckoutRouteChildren = {
  CheckoutSuccessRoute: CheckoutSuccessRoute,
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(
  CheckoutRouteChildren,
)

interface ArticlesArticleIdRouteChildren {
  ArticlesArticleIdEditRoute: typeof ArticlesArticleIdEditRoute
}

const ArticlesArticleIdRouteChildren: ArticlesArticleIdRouteChildren = {
  ArticlesArticleIdEditRoute: ArticlesArticleIdEditRoute,
}

const ArticlesArticleIdRouteWithChildren =
  ArticlesArticleIdRoute._addFileChildren(ArticlesArticleIdRouteChildren)

interface QuizletsQuizletIdRouteChildren {
  QuizletsQuizletIdEditRoute: typeof QuizletsQuizletIdEditRoute
}

const QuizletsQuizletIdRouteChildren: QuizletsQuizletIdRouteChildren = {
  QuizletsQuizletIdEditRoute: QuizletsQuizletIdEditRoute,
}

const QuizletsQuizletIdRouteWithChildren =
  QuizletsQuizletIdRoute._addFileChildren(QuizletsQuizletIdRouteChildren)

interface ArticlesCollectionsCollectionIdRouteChildren {
  ArticlesCollectionsCollectionIdArticlesArticleIdRoute: typeof ArticlesCollectionsCollectionIdArticlesArticleIdRoute
}

const ArticlesCollectionsCollectionIdRouteChildren: ArticlesCollectionsCollectionIdRouteChildren =
  {
    ArticlesCollectionsCollectionIdArticlesArticleIdRoute:
      ArticlesCollectionsCollectionIdArticlesArticleIdRoute,
  }

const ArticlesCollectionsCollectionIdRouteWithChildren =
  ArticlesCollectionsCollectionIdRoute._addFileChildren(
    ArticlesCollectionsCollectionIdRouteChildren,
  )

interface QuizletsDeckGroupsGroupIdRouteChildren {
  QuizletsDeckGroupsGroupIdEditRoute: typeof QuizletsDeckGroupsGroupIdEditRoute
}

const QuizletsDeckGroupsGroupIdRouteChildren: QuizletsDeckGroupsGroupIdRouteChildren =
  {
    QuizletsDeckGroupsGroupIdEditRoute: QuizletsDeckGroupsGroupIdEditRoute,
  }

const QuizletsDeckGroupsGroupIdRouteWithChildren =
  QuizletsDeckGroupsGroupIdRoute._addFileChildren(
    QuizletsDeckGroupsGroupIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  CheckoutRoute: CheckoutRouteWithChildren,
  DailyKnowledgeRoute: DailyKnowledgeRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  SignupRoute: SignupRoute,
  AnalyticsQuizletIdRoute: AnalyticsQuizletIdRoute,
  AnalyticsQuizletsRoute: AnalyticsQuizletsRoute,
  ArticlesArticleIdRoute: ArticlesArticleIdRouteWithChildren,
  ArticlesCreateRoute: ArticlesCreateRoute,
  ArticlesPublicRoute: ArticlesPublicRoute,
  QuizletsQuizletIdRoute: QuizletsQuizletIdRouteWithChildren,
  QuizletsCreateRoute: QuizletsCreateRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  ArticlesIndexRoute: ArticlesIndexRoute,
  QuizletsIndexRoute: QuizletsIndexRoute,
  ReviewCenterIndexRoute: ReviewCenterIndexRoute,
  ArticlesCollectionsCollectionIdRoute:
    ArticlesCollectionsCollectionIdRouteWithChildren,
  QuizletsDeckGroupsGroupIdRoute: QuizletsDeckGroupsGroupIdRouteWithChildren,
  QuizletsDeckGroupsCreateRoute: QuizletsDeckGroupsCreateRoute,
  ReviewCenterQuizIdPracticeRoute: ReviewCenterQuizIdPracticeRoute,
  ReviewCenterQuizIdReviewRoute: ReviewCenterQuizIdReviewRoute,
  ArticlesCollectionsIndexRoute: ArticlesCollectionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
